import { useEffect, useState } from 'react';

const QUERY = '(min-width: 900px)';

// True on tablet/desktop (two columns). False where matchMedia is missing.
export default function useWideLayout() {
  const read = () => typeof window !== 'undefined'
    && typeof window.matchMedia === 'function'
    && window.matchMedia(QUERY).matches;
  const [wide, setWide] = useState(read);

  useEffect(() => {
    if (typeof window.matchMedia !== 'function') return undefined;
    const media = window.matchMedia(QUERY);
    const onChange = () => setWide(media.matches);
    onChange();
    // Old Safari / WebViews only have addListener.
    if (typeof media.addEventListener === 'function') {
      media.addEventListener('change', onChange);
      return () => media.removeEventListener('change', onChange);
    }
    media.addListener(onChange);
    return () => media.removeListener(onChange);
  }, []);

  return wide;
}

export { useWideLayout };
